/**
 * §3: centred, muted and **instructive** — "No transfer indents yet. Raise one
 * above." The instruction is the point. An empty table that only says "No data"
 * leaves the reader unsure whether the system is broken, their filter is wrong,
 * or there is genuinely nothing yet.
 */
export function EmptyState({
  title,
  hint,
  icon,
}: {
  title: string
  hint: string
  icon?: React.ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-14 text-center">
      {icon && <div className="mb-3 text-dpl-muted/60">{icon}</div>}
      <p className="text-sm font-medium text-dpl-text">{title}</p>
      <p className="mt-1 max-w-sm text-sm text-dpl-muted">{hint}</p>
    </div>
  )
}
